import { UpperCaseGateway } from '@/models/gateway-type';
import Bluesnap from './gateway/bluesnap';
import ChargebeePayments from './gateway/chargebee_payments';
import CheckoutCom from './gateway/checkout_com';
import Braintree from './gateway/braintree';
import Stripe from './gateway/stripe';
import Gocardless from './gateway/gocardless';
import Adyen from './gateway/adyen';
import PayPal from './gateway/paypal';

export default class CbjsTransformer {

  static get(pm, paymentData, store) {
    switch(pm.gateway_name) {
      case UpperCaseGateway.CHARGEBEE_PAYMENTS:
        return ChargebeePayments.get(pm, paymentData, store)
      case UpperCaseGateway.BLUESNAP:
        return Bluesnap.get(pm, paymentData, store)
      case UpperCaseGateway.CHECKOUT_COM:
        return CheckoutCom.get(pm, paymentData, store)
      case UpperCaseGateway.BRAINTREE:
        return Braintree.get(pm, paymentData, store)
      case UpperCaseGateway.ADYEN:
        return Adyen.get(pm, paymentData, store)
      case UpperCaseGateway.STRIPE:
        return Stripe.get(pm, paymentData, store)
      case UpperCaseGateway.GOCARDLESS:
        return Gocardless.get(pm, paymentData, store)
      case UpperCaseGateway.PAYPAL:
        return PayPal.get(pm, paymentData, store)
    }
  }

}
